<ng-container>
  <h1
    *ngIf="type === TextType.TITLE && heading === TextHeadingLevel.PAGE"
    [attr.data-test-id]="testId"
    class="text--base text--size-{{ size }} text--weight-{{
      weight
    }} text--height-{{ height }} text--color-{{ color }} text--align-{{
      align
    }} text--spacing-{{ spacingBottom }} text--style-{{ style }}"
  >
    <ng-container *ngTemplateOutlet="headingTemplate"></ng-container>
  </h1>
  <h2
    *ngIf="type === TextType.TITLE && heading === TextHeadingLevel.CONTENT"
    [attr.data-test-id]="testId"
    class="text--base text--size-{{ size }} text--weight-{{
      weight
    }} text--height-{{ height }} text--color-{{ color }} text--align-{{
      align
    }} text--spacing-{{ spacingBottom }} text--style-{{ style }}"
  >
    <ng-container *ngTemplateOutlet="headingTemplate"></ng-container>
  </h2>
  <p
    *ngIf="type === TextType.BODY"
    [attr.data-test-id]="testId"
    class="text--base text--size-{{ size }} text--weight-{{
      weight
    }} text--height-{{ height }} text--color-{{ color }} text--align-{{
      align
    }} text--spacing-{{ spacingBottom }} text--style-{{ style }}"
  >
    <ng-container *ngTemplateOutlet="headingTemplate"></ng-container>
  </p>
</ng-container>

<ng-template #headingTemplate>
  <ng-content></ng-content>
</ng-template>
